import {useTranslation} from 'react-i18next';
import MainScreenButton from '../../../../../components/forms/mainScreenButton';
import React from 'react';
import {useDispatch} from 'react-redux';
import moment from 'moment';

const FirstClinicianButton = ({patient, disableSave}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const value = patient?.firstClinician || {who: null, when: moment()};

    return (
        <MainScreenButton
            value={value}
            filled={value && value.who && value.when}
            disabled={disableSave}
            label={t('First Clerking Clinician')}
            // onOpen={() => dispatch(openPatientForm('firstClinician'))}
            disableEdit
        />
    );
};

export default FirstClinicianButton;
